/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Group_AppsInputs */



/**
* | output |
* | --- |
* | "Apps" |
*
* @param {P1portal_Group_AppsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_group_apps = /** @type {((inputs?: P1portal_Group_AppsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Group_AppsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Apps")
});